'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import { ContentTypeVariations } from '@/components/organisms';

type TranslatedContentTypeProps = {
  contentType: ContentTypeVariations;
};

export const TranslatedContentType = ({
  contentType,
}: TranslatedContentTypeProps) => {
  const t = useTranslations();
  return <>{t(`CONTENT_TYPE_${contentType.toUpperCase()}`)}</>;
};
